// Module
var code = "<div class=\"active-files-container\"> <div class=\"afc-preloader-container\" ng-if=\"!vm.showContent\"> <preloader-dot class=\"afc-icon-preloader\"> </preloader-dot> </div> <div class=\"afc-content-container\" ng-if=\"vm.showContent\"> Content </div> </div> ";
// Exports
module.exports = code;